<template>
    <div class="text-left row p-3" id="calendar-detail">
        <div class="col-md-6 mb-3">
            <div class="invisible-sm">
                <h5 class="m-0">Geselecteerde datum:</h5>
                <p>{{date.date.toLocaleDateString()}}</p>
            </div>
            <h5>Beschikbaarheid</h5>
            <div class="form-check">
                <input class="form-check-input" type="radio" name="availability" id="availability1" :value="false" v-model="date.blocked" @change="save('Blocked', date.blocked)" >
                <label class="form-check-label" for="availability1">
                    Beschikbaar
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" name="availability" id="availability2" :value="true" v-model="date.blocked" @change="save('Blocked', date.blocked)" >
                <label class="form-check-label" for="availability2">
                    Geblokkeerd
                </label>
            </div>

            <div class="mt-3 mb-0" v-if="!date.blocked && date.availability">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="checkAvailabilityDay" v-model="date.availability.day" @change="save('Availability', date.availability)">
                    <label class="custom-control-label" for="checkAvailabilityDay">Overdag (07:00 - 18:00)</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="checkAvailabilityEvening" v-model="date.availability.evening" @change="save('Availability', date.availability)">
                    <label class="custom-control-label" for="checkAvailabilityEvening">Avond (18:00 - 24:00)</label>
                </div>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="checkAvailabilityNight" v-model="date.availability.night" @change="save('Availability', date.availability)">
                    <label class="custom-control-label" for="checkAvailabilityNight">Nacht (24:00 - 07:00)</label>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <h5>Tarieven</h5>
            <rates :date="date" @save="save" :horizontal="true" :demo="demo"></rates>
        </div>
    </div>
</template>

<script>
import Rates from '@/components/Rates';
export default {
    name: 'calendar-detail',
    props: {
        demo: {
            required: false,
            type: Boolean,
            default: false
        },
        date: {
            required: true,
            type: Object
        }
    },
    components: {
        Rates
    },
    data() {
        return {
        }
    },
    methods: {
        save(property, value) {
            if(!this.demo)
            {
                return this.$http.post('api/Rates/' + property + '?date=' + this.date.date.toDateString(), JSON.stringify(value)).then(() => {
                    this.$emit('update', { property: property, value: value})
                });
            }
        },
        saveAvailability(value) {
            if(!this.demo)
            {
                return this.$http.post('api/Rates/Availability?date=' + this.date.date.toDateString(), JSON.stringify(value)).then(() => {
                    this.$emit('update', { property: property, value: value})
                });
            }
        }
    },
    watch: {
    }
}
</script>

<style scoped lang="scss">
#calendar-detail {
    background-color: $lightColor;
    border-bottom: 1px solid $darkColor;
}
button.round {
    float: left;
}


</style>